import { LegendContent } from './legend-content'
import { LEGEND_SHAPE } from './legend-key'
import { useStyles } from './legend.style'

export const SHAPE = LEGEND_SHAPE

export const Legend = function ({ className = '', children, enableBorder = false, labels = [], colors, shape, toggleDefaults, onToggle, position = 'right' }) {
  const classes = useStyles()

  return (
    <div className={`${classes.legendWrapper} ${enableBorder ? classes.border : ''} ${className}`}>
      {position === 'right' && <div className={classes.left}>{children}</div>}
      <LegendContent labels={labels} colors={colors} shape={shape} toggleDefaults={toggleDefaults} onToggle={onToggle} />
    </div>
  )
}
